import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/bin.tsx
var Bin = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M6 6V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V6M6 6H18M6 6H4M18 6H20M9 6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6M14 11V16M10 11V16",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.32501 5C8.67247 3.28832 10.1858 2 12 2C13.8142 2 15.3275 3.28832 15.675 5H20.25C20.6642 5 21 5.33579 21 5.75C21 6.16421 20.6642 6.5 20.25 6.5H19V19.25C19 20.7688 17.7688 22 16.25 22H7.75C6.23122 22 5 20.7688 5 19.25V6.5H3.75C3.33579 6.5 3 6.16421 3 5.75C3 5.33579 3.33579 5 3.75 5H8.32501ZM9.87803 5C10.1869 4.12611 11.0203 3.5 12 3.5C12.9797 3.5 13.8131 4.12611 14.122 5H9.87803ZM10 10C10.4142 10 10.75 10.3358 10.75 10.75V16.25C10.75 16.6642 10.4142 17 10 17C9.58579 17 9.25 16.6642 9.25 16.25V10.75C9.25 10.3358 9.58579 10 10 10ZM14 10C14.4142 10 14.75 10.3358 14.75 10.75V16.25C14.75 16.6642 14.4142 17 14 17C13.5858 17 13.25 16.6642 13.25 16.25V10.75C13.25 10.3358 13.5858 10 14 10Z",
		fill: "currentColor"
	})
});
//#endregion
export { Bin };
